<!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events -->
<div class="chat-button" (click)="openChat()" title="Chat with us" tabindex="0">💬</div>
